export default __webpack_public_path__ + "static/media/open.2d6f260e.wav";